import React from 'react';
import { scopeContext } from './scope-context';
import { ErrorBoundary } from './ErrorBoundary';

type Props = {
  children: React.ReactNode;
  fallback?: JSX.Element;
  scope: string;
};

export function ScopeProvider(props: Props) {
  const { children, fallback, scope } = props;

  const { Provider } = scopeContext;
  return (
    <Provider value={scope}>
      <ErrorBoundary fallback={fallback} scope={scope}>
        {children}
      </ErrorBoundary>
    </Provider>
  );
}
